import { render } from "./FaleConosco.vue?vue&type=template&id=10a59c36&scoped=true"
import script from "./FaleConosco.vue?vue&type=script&lang=js"
export * from "./FaleConosco.vue?vue&type=script&lang=js"

import "./FaleConosco.vue?vue&type=style&index=0&id=10a59c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a59c36"]])

export default __exports__